module.exports = __webpack_public_path__ + "img/sonata-25.34e749fd.png";